// extracted by mini-css-extract-plugin
export default {"root":"F9d1b","cover":"sD95N","middle":"_2mIhE","mature-block":"_2KawB","matureBlock":"_2KawB","underlay":"_2XRd8"};